var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{class:{'is-hidden': _vm.isHidden}},[_vm._v(_vm._s(_vm.line))])}
var staticRenderFns = []

export { render, staticRenderFns }